import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { HotKeys } from 'react-hotkeys'
import DocumentTitle from 'react-document-title'
import classnames from 'classnames'

import { makeDefaultFailedContainer } from 'components/container'
import IconSVG from 'svg-inline-react'
import { GlobalSearch, GLOBAL_SEARCH_KEY, openGlobalSearch } from 'components/GlobalSearch'
import { APP_TITLE } from 'constants/ResourcesConstants'
import { Link } from 'react-router'

import 'styles/components/App'
import styles from './style.styl'

import closeButtonSrc from '!svg-inline?removeTags=true!images/icons/times-icon.svg'

export class Header extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    location: PropTypes.object
  }
  static propTypes = {
    leftNav: PropTypes.element,
    rightNav: PropTypes.element,
    title: PropTypes.string.isRequired,
    titleNode: PropTypes.element,
    showClose: PropTypes.bool,
    closePath: PropTypes.string,
    showTitle: PropTypes.bool
  }

  static defaultProps = {
    showClose: true,
    showTitle: true,
    closePath: '/home'
  }

  handleOpenSearch = () => {
    openGlobalSearch(this.context)
  }

  componentDidMount() {
    this.focusHeader()
  }

  getTotalMessageCount() {
    if (!this.props.inboxesById) return
    return _.chain(this.props.inboxesById)
      .sum('openConversationCount')
      .value()
  }

  getDocumentTitle() {
    const totalMessageCount = this.getTotalMessageCount()
    const prefix = totalMessageCount > 0 ? `(${ totalMessageCount }) ` : ''
    return `${prefix}${APP_TITLE} - ${this.props.title}`
  }

  closeSearch() {
    const query = _.cloneDeep(this.context.location.query)
    delete query[GLOBAL_SEARCH_KEY]
    this.context.router.push({ pathname: this.context.location.pathname, query })
    this.focusHeader()
  }

  focusHeader() {
    const node = ReactDOM.findDOMNode(this.refs.refHeader)
    node && node.focus()
  }

  render() {
    let globalSearch = null
    if (this.context.location && this.context.location.query[GLOBAL_SEARCH_KEY] != undefined) {
      globalSearch = (
        <GlobalSearch
          onClose={this.closeSearch.bind(this)}
          query={this.context.location.query}>
        </GlobalSearch>
      )
    }

    let pageTitle = null
    if (this.props.showTitle) {
      pageTitle = (
        <span className={styles.headerTitle}>{this.props.titleNode || this.props.title}</span>
      )
    }

    return (
      <DocumentTitle title={this.getDocumentTitle()}>
        <HotKeys
          handlers={{ openSearch: this.handleOpenSearch }}
          keyMap={{ openSearch: 'command+/' }}>
          <div className={classnames(styles.Header, { navy: this.props.navy })} ref="refHeader" style={this.props.style}>
            <div className={styles.leftColumn}>
              {this.props.leftNav || null}
            </div>
            <div className={styles.centerColumn}>
              {pageTitle}
            </div>
            <div className={ `${styles.rightColumn} flex-center` }>
              {this.props.rightNav || null}
              {this.renderCloseButton()}
            </div>
          </div>
          {globalSearch}
          <div className={styles.RestContent}>
            {this.props.children}
          </div>
        </HotKeys>
      </DocumentTitle>
    )
  }

  renderCloseButton() {
    if (this.props.showClose) {
      const closeIcon = <IconSVG src={closeButtonSrc} alt="Close Page"/>

      if (!!this.props.onClose) {
        return (
          <div onClick={ this.props.onClose }
               className={styles.headerClose}
               alt="Close Page">
            {closeIcon}
          </div>
        )
      } else if (!!this.props.closePath) {
        return (
          <Link className={styles.headerClose} to={ this.props.closePath }>
            {closeIcon}
          </Link>
        )
      }
    }
  }
}

const container = makeDefaultFailedContainer(Header, {
  listenTo: ['stores.InboxStore', 'stores.GateStore'],
  fetch: {
    gates() {
      return this.app.stores.GateStore.getOrFetchGates()
    },
    inboxesById() {
      return this.app.stores.InboxStore.getOrFetchInboxList()
    }
  }
})

export default container



// WEBPACK FOOTER //
// ./src/scripts/components/nav/Header/index.js